import { CircuitDayFormData } from '@/types/circuits/CircuitDaysFormData';
import { isRowReservedForAssociatedBenefits } from './isRowReservedForAssociatedBenefits';

export const findNextAvailableStepIndex = (
  candidateIndex: number,
  steps: CircuitDayFormData['steps'],
): number => {
  let index = Math.max(candidateIndex, 0);

  while (
    index < steps.length &&
    isRowReservedForAssociatedBenefits(steps[index])
  ) {
    index++;
  }

  return index;
};
